import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import translationEn from "./locales/en/translation.json";
import translationAr from "./locales/ar/translation.json";

i18n
  .use(initReactI18next)
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "ar",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      ar: {
        translations: translationAr,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;